<template lang="pug">
    li(
        :class="clss"
        @mouseover="hover"
        @mouseleave="blur"
    )
        .tree-item
            a(v-if="item.page && item.page.view === 'Logout'" @click="signout") {{ item.title }}
            a(v-else-if="redirect" :href="href" :title="item.title" :target="target") {{ item.title }}
            router-link(v-else :to='item.path') {{ item.title }}
            button(
                v-if="toggleEvent === 'click' && children && children.length && ( ! maxDepth || depth < maxDepth)"
                type="button"
                :aria-expanded="active ? 'true' : 'false'"
                :aria-label="'Untermenü ' + item.title"
                @click="active ? close() : open()"
            )
                font-awesome-icon(:icon="active ? 'chevron-up' : 'chevron-down'")
        tree-menu(
            v-if="children.length && ( ! maxDepth || depth < maxDepth)"
            :items="children" :depth="depth + 1" :max-depth="maxDepth"
            :show="active"
        )

</template>

<script>

import get from 'lodash.get'
import startsWith from 'lodash.startswith'
import { mapActions } from 'vuex'

export default {
    name: 'TreeMenuItem',
    data() {
        return {
            timeout: undefined,
            visible: false,
            mouseover: false,
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        maxDepth: {
            type: Number,
        },
        toggleEvent: {
            type: String,
            required: true,
        },
        current: {
            type: Object,
        },
        delay: {
            type: Number,
            required: true,
        },
        allowMultipleActiveItems: {
            type: Boolean,
            required: true,
        },
        fullWidthThreshold: {
            type: Number,
        },
    },
    computed: {
        active() {
            if (this.allowMultipleActiveItems === true) return this.visible
            return this.visible && this.current && this.item.id === this.current.id
        },
        focused() {
            if (this.allowMultipleActiveItems === true) return this.mouseover
            return this.mouseover && this.current && this.item.id === this.current.id
        },
        redirect() {
            const view = get(this.item, 'page.view')
            if (view === 'Redirect' && this.hyperlink.type !== 'internal' && this.hyperlink.href) return true
            return false
        },
        hyperlink() {
            return get(this.item, 'page.hyperlink') || {}
        },
        href() {
            let href = false

            if (this.redirect) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! startsWith(link, 'https://') && ! startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return get(this.hyperlink, 'target') || '_self'
        },
        children() {
            let children = []
            if (this.item.children && this.item.children.length) {
                children = this.item.children.filter(item => ! item.disabled && ! item.hidden)
            }

            return children
        },
        clss() {
            let value = []

            if (this.active) value.push('visible')
            if (this.focused) value.push('hover')
            if (this.children.length) value.push('has-children')
            if (this.depth === 1 && this.children.length >= this.fullWidthThreshold) value.push('full-width')

            return value
        }
    },
    methods: {
        hover() {
            if (this.timeout) clearTimeout(this.timeout)
            if (this.toggleEvent === 'hover') {
                this.$emit('focus', this.item)
                this.visible = true
            }
            this.mouseover = true
        },
        blur() {
            this.timeout = setTimeout(() => {
                if (this.toggleEvent === 'hover') {
                    this.$emit('blur', this.item)
                    this.visible = false
                }
                this.mouseover = false
            }, this.delay);
        },
        open() {
            if (this.toggleEvent === 'click') {
                this.$emit('open', this.item)
                this.visible = true
            }
        },
        close() {
            if (this.toggleEvent === 'click') {
                this.$emit('close', this.item)
                this.visible = false
            }
        },
        ...mapActions({
            signout: 'auth/signout',
        })
    }
}
</script>

<style lang="sass" scoped></style>
